import { Resolvers } from '../../../constants/types';
import {
  SetSelectedPortMutationVariables,
  ListPortsQuery,
} from '../../../generated/gql';

import LIST_PORTS from '../graphql/listPorts';

const resolvers: Resolvers = {
  Mutation: {
    setSelectedPort: (
      _,
      variables: SetSelectedPortMutationVariables,
      { cache },
    ) => {
      const data = cache.readQuery<ListPortsQuery>({ query: LIST_PORTS });
      const listPorts = data?.listPorts;

      cache.writeQuery<ListPortsQuery>({
        query: LIST_PORTS,
        data: { listPorts, selectedPort: variables.port },
      });

      window.localStorage.setItem('selectedPort', variables.port || '');
    },
  },
  Query: {
    selectedPort: (root: ListPortsQuery) => {
      const selected = window.localStorage.getItem('selectedPort');

      if (root.listPorts?.length) {
        if (
          selected === '' ||
          root.listPorts?.some((port) => port?.code === selected)
        ) {
          return selected;
        }
        if (root.listPorts?.length) return root.listPorts[0]?.code;
      }
      return undefined;
    },
  },
};

export default resolvers;
